import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SalesLeadManagement from '../components/SalesLeadManagement';
import LeadManagementDetail from '../components/LeadManagementDetail';

const SalesLeadManagementPage = () => {
    return (
        <Routes>
            <Route path="/" element={<SalesLeadManagement />} />
            <Route path="/:id" element={<LeadManagementDetail />} />
        </Routes>
    );
};

export default SalesLeadManagementPage;